var map = {
	"./bootstrap.png": 9865,
	"./css.png": 3277,
	"./database.png": 1036,
	"./draw.png": 8426,
	"./figma.png": 1805,
	"./gaming.png": 4829,
	"./github.png": 2980,
	"./gta.png": 5619,
	"./html.png": 9475,
	"./javascript.png": 6860,
	"./kitty.png": 7746,
	"./movie.png": 4538,
	"./nodejs.png": 9463,
	"./photoshop.png": 7441,
	"./rdr.png": 6626,
	"./react.png": 8827,
	"./sass.png": 6496,
	"./storybook.png": 6327,
	"./typescript.png": 7082,
	"./unity.png": 371,
	"./vscode.png": 6123,
	"./vuforia.png": 6712,
	"./xbox.png": 702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4266;